import { ALL_VALUATION_STAGES, VALID_CURRENT_VALUATION_STAGES, VALID_PAST_VALUATION_STAGES, ValuationStatus } from 'dashboard409a/pages/Workboard/common/types';

// ============================================================================
// SORTING TYPES
// ============================================================================

export type AttioSortDirection = 'asc' | 'desc';

export type AttioSortAttribute = 'identifier' | 'stage' | 'valuation_date' | 'valuation_fee';

export type AttioSort = {
  direction: AttioSortDirection;
  attribute: AttioSortAttribute;
};

// Sort criteria for local sorting (supports any property string)
export type SortCriteria = {
  property: string;
  direction: AttioSortDirection;
};

// ============================================================================
// FILTER TYPES
// ============================================================================

// Base filter conditions
export type AttioStageCondition = {
  stage?: ValuationStatus;
};

export type AttioNotStageCondition = {
  $not: { stage: ValuationStatus };
};

// OR conditions for stages
export type AttioStageOrCondition = {
  $or: Array<AttioStageCondition>;
};

// AND conditions
export type AttioStageAndCondition = {
  $and: Array<AttioStageOrCondition | AttioNotStageCondition>;
};

// Main filter type
export type AttioValuationFilter = {
  $or?: Array<AttioStageCondition>;
  $and?: AttioStageAndCondition['$and'];
  limit?: number;
  offset?: number;
  sorts?: AttioSort[];
};

// ============================================================================
// QUERY BODY TYPES
// ============================================================================

// User-specific conditions for query body
export type AttioUserCondition = {
  valuation_lead_94?: { target_record_id: string };
  other_consultant?: { target_record_id: string };
};

// Combined conditions for query body
export type AttioQueryCondition = AttioUserCondition & AttioStageCondition;

// Main query body type
export type AttioValuationQueryBody = {
  filter: {
    $or: Array<AttioQueryCondition>;
    $and?: AttioValuationFilter['$and'];
  };
  limit: number;
  offset: number;
  sorts?: AttioSort[];
};

// ============================================================================
// FILTER CONSTANTS
// ============================================================================

// Past valuations filter (Final sent and cancelled)
export const ATTIO_PAST_VALUATIONS_FILTER: AttioValuationFilter = {
  $and: [
    {
      $or: VALID_PAST_VALUATION_STAGES.map((stage: ValuationStatus) => ({ stage })),
    }
  ],
};

// Current valuations filter (Rest of the stages)
export const ATTIO_CURRENT_VALUATIONS_FILTER: AttioValuationFilter = {
  $and: [
    {
      $or: VALID_CURRENT_VALUATION_STAGES.map((stage: ValuationStatus) => ({ stage })),
    },
  ],
};

// Opportunities filter (stage = NULL)
export const ATTIO_OPPORTUNITIES_FILTER: AttioValuationFilter = {
  $and: ALL_VALUATION_STAGES.map((stage: ValuationStatus) => ({
    $not: { stage },
  })),
};

export const FULFILLMENT_DATE_KEY = 'valuation_date';
export const FULFILLMENT_COMPANY_NAME_KEY = 'company_name';
export const FULFILLMENT_MODEL_STATUS_KEY = 'model_status';
export const FULFILLMENT_MODEL_DUE_DATE_KEY = 'model_due_date';